import { useLocation } from "react-router-dom";
import {
  REACT_APP_PREOWNED_ENABLED,
  REACT_APP_PREOWNED_PT_FEATURES,
  REACT_APP_PREOWNED_SITE_URL,
} from "../config";
import { defaultTheme } from "./defaultTheme";
import { preownedTheme } from "./preownedTheme";

/** Route prefix that puts the admin into pre-owned mode. */
export const PREOWNED_PREFIX = "/preowned";
/** Path the "Pre-Owned" switch lands on. */
export const PREOWNED_HOME = `${PREOWNED_PREFIX}/watches`;
/** False on PT until the pre-owned admin replaces the CodeIgniter one. */
export const PREOWNED_ENABLED = REACT_APP_PREOWNED_ENABLED;
/**
 * PT-only pre-owned features. Watchfinder and WatchSource are PT sales
 * channels; TPC ships the same code with this off rather than forking.
 */
export const PREOWNED_PT_FEATURES = REACT_APP_PREOWNED_PT_FEATURES;
/** Root of the customer-facing pre-owned site. Empty disables the links. */
export const PREOWNED_SITE_URL = REACT_APP_PREOWNED_SITE_URL.replace(/\/+$/, "");

/**
 * Mode is derived from the URL rather than stored, so a refresh, a deep link
 * or the back button can never leave the chrome disagreeing with the page.
 */
export function usePreownedMode() {
  const { pathname } = useLocation();
  if (!PREOWNED_ENABLED) return false;
  return (
    pathname === PREOWNED_PREFIX || pathname.startsWith(`${PREOWNED_PREFIX}/`)
  );
}

/** The MUI theme for whichever admin the current route belongs to. */
export function useActiveTheme() {
  return usePreownedMode() ? preownedTheme : defaultTheme;
}